import React, { useEffect, useState } from "react";
import MainLayout1 from "Components/UI/Layout/MainLayout1";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useLoaderData, useNavigate } from "react-router-dom";
import { getAllClientArticles } from "API/swesum";
import ClientArticlesTableContainer from "Components/Article/ClientArticlesTableContainer";

export async function loader() {
  const clientArticles = await getAllClientArticles();
  return { clientArticles };
}

export default function ClientsArticles() {
  const navigate = useNavigate();
  const [clientArticles, setClientArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const asyncFetchClientArticles = async () => {
      const clientArticles = await getAllClientArticles();
      setClientArticles(clientArticles);
      setLoading(false);
    };
    asyncFetchClientArticles();
  }, []);
  return (
    <>
      <MainLayout1>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1.0rem",
          }}
        >
          <Typography variant="h5">Klientartiklar</Typography>
          <Button
            onClick={() => navigate("create")}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
          >
            SKAPA NY
          </Button>
        </Box>
        {!loading ? (
          <ClientArticlesTableContainer articles={clientArticles} />
        ) : null}
      </MainLayout1>
    </>
  );
}
